import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import { RecordDetail } from '../../procurement/face/ApprovalsDetailModal';
import { RECORD_TYPES } from '../../procurement/face/approvalsHelpers';

/** The server's lowercase record kinds, mapped onto the detail body's record types. */
const RECORD_PAGE_TYPES = { ea: RECORD_TYPES.EA, dc: RECORD_TYPES.DC, pr: RECORD_TYPES.PR };

/**
 * One purchase order or requisition, read-only, for an approver who cannot open the Procurement
 * dashboard. Renders the same detail body as the dashboard's drawer, from the payload embedded in
 * the page rather than a fetch: the show endpoints sit behind the Procurement module this viewer
 * may not hold.
 */
export default function HomeRecordPage({ recordPage, currencySymbol, approvalStatuses, attachmentUrl }) {
    return (
        <div className="tw-rounded-lg tw-bg-white tw-px-6 tw-py-5 tw-shadow-primary">
            {recordPage.unavailable || !recordPage.record ? (
                <p className="tw-py-6 tw-text-center tw-text-sm tw-text-charcoal-50">{$t('This record is no longer available.')}</p>
            ) : (
                <RecordDetail
                    type={RECORD_PAGE_TYPES[recordPage.type]}
                    payload={recordPage.record}
                    currencySymbol={currencySymbol}
                    attachmentUrl={attachmentUrl}
                    approvalStatuses={approvalStatuses}
                />
            )}
        </div>
    );
}

const parseJson = (raw, fallback) => {
    try {
        return JSON.parse(raw) ?? fallback;
    } catch (error) {
        return fallback;
    }
};

const rootEl = document.getElementById('HomeRecordPage');

if (rootEl) {
    ReactDOM.render(
        <App>
            <HomeRecordPage
                recordPage={parseJson(rootEl.getAttribute('data-record-page'), { unavailable: true })}
                currencySymbol={rootEl.getAttribute('data-currency-symbol') || ''}
                approvalStatuses={parseJson(rootEl.getAttribute('data-display-approval-statuses'), undefined)}
                attachmentUrl={rootEl.getAttribute('data-download-attachment-url')}
            />
        </App>,
        rootEl,
    );
}
